module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('header', {
    staticClass: "header",
    class: {
      'header-fixed': _vm.headerFixed
    },
    staticStyle: {
      "background-color": "rgb(9,172,248)"
    }
  }, [_c('el-row', [_c('el-col', {
    staticClass: "logo",
    attrs: {
      "md": 16,
      "sm": 12
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    attrs: {
      "src": require("./assets/imfbp_logo.png"),
      "alt": "Logo"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "topTitle"
  }, [_vm._v("我的工作台")])]), _vm._v(" "), _c('el-col', {
    staticClass: "person-set",
    attrs: {
      "md": 8,
      "sm": 12
    }
  }, [_c('user'), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "font-szie": "18px"
    },
    attrs: {
      "type": "text"
    },
    on: {
      "click": _vm.openDialog
    }
  }, [(!_vm.addCard) ? _c('i', {
    staticClass: "el-icon-plus",
    staticStyle: {
      "color": "#FFFFFF"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.addCard) ? _c('i', {
    staticClass: "el-icon-close",
    staticStyle: {
      "color": "#FFFFFF"
    }
  }) : _vm._e()])], 1)], 1)], 1), _vm._v(" "), _c('main', [_c('mainNav', {
    class: {
      'left-fixed': _vm.leftFixed
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "main-right"
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('router-view', {
    staticClass: "view",
    staticStyle: {
      "display": "flex",
      "flex-direction": "column",
      "padding-bottom": "100px"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('sideDialog', {
    attrs: {
      "show": _vm.addCard
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-5497f3d0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 507
// module chunks = 1